var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-linear',{attrs:{"active":!!_vm.goal.target_amount,"height":"20","rounded":"","striped":"","value":(_vm.goal.starting_amount / _vm.goal.target_amount) * 100,"color":"light-blue","disabled":_vm.disabled}})}
var staticRenderFns = []

export { render, staticRenderFns }